import { useAuthStore } from './chunk-XW7GX6IX.js';
export { authEvents, useAuthStore } from './chunk-XW7GX6IX.js';
import { useEffect } from 'react';
import { jsx, Fragment } from 'react/jsx-runtime';

// src/hooks/useAuth.ts
function useAuth() {
  const user = useAuthStore((s) => s.user);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isLoading = useAuthStore((s) => s.isLoading);
  return { user, isAuthenticated, isLoading };
}

// src/permissions/rolePermissions.ts
var ADMIN_FULL = [
  "kyc:view",
  "kyc:approve",
  "ledger:view",
  "ledger:manage",
  "pos:operate",
  "loans:manage",
  "partner:manage",
  "compliance:review",
  "admin:manage-tenants",
  "admin:manage-users",
  "reports:view"
];
var RM_PERMS = ["kyc:view", "kyc:approve", "ledger:view", "compliance:review", "reports:view"];
var LENDER_PERMS = ["loans:manage", "kyc:view", "reports:view"];
var ROLE_PERMISSIONS = {
  PLATFORM_ADMIN: ADMIN_FULL,
  TENANT_ADMIN: [
    "kyc:view",
    "kyc:approve",
    "ledger:view",
    "ledger:manage",
    "pos:operate",
    "loans:manage",
    "partner:manage",
    "compliance:review",
    "admin:manage-users",
    "reports:view"
  ],
  RELATIONSHIP_MANAGER: RM_PERMS,
  COMPLIANCE_OFFICER: ["kyc:view", "kyc:approve", "compliance:review", "reports:view"],
  OPERATIONS: ["kyc:view", "ledger:view", "reports:view"],
  JEWELLER: ["pos:operate", "ledger:view", "reports:view"],
  AGENT: ["loans:manage", "kyc:view", "reports:view"],
  LENDER: LENDER_PERMS,
  SAVER: [],
  // ── deprecated aliases (mirror their canonical role) ──
  RM: RM_PERMS,
  CUSTOMER: []
};
function roleHasPermission(roles, permission) {
  return roles.some((role) => ROLE_PERMISSIONS[role]?.includes(permission));
}

// src/hooks/usePermission.ts
function usePermission(permission) {
  const roles = useAuthStore((s) => s.roles);
  return roleHasPermission(roles, permission);
}

// src/hooks/useCsrfToken.ts
function useCsrfToken() {
  return useAuthStore((s) => s.user?.csrfToken ?? null);
}
function AuthGuard({
  children,
  fallback = null,
  requiredRoles,
  onUnauthenticated,
  onForbidden
}) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isLoading = useAuthStore((s) => s.isLoading);
  const roles = useAuthStore((s) => s.roles);
  const isForbidden = isAuthenticated && !!requiredRoles && requiredRoles.length > 0 && !requiredRoles.some((role) => roles.includes(role));
  useEffect(() => {
    if (isLoading) return;
    if (!isAuthenticated) {
      onUnauthenticated?.();
      return;
    }
    if (isForbidden) {
      onForbidden?.();
    }
  }, [isLoading, isAuthenticated, isForbidden]);
  if (isLoading) return /* @__PURE__ */ jsx(Fragment, { children: fallback });
  if (!isAuthenticated) return null;
  if (isForbidden) return null;
  return /* @__PURE__ */ jsx(Fragment, { children });
}
function PermissionGuard({ permission, children, fallback = null }) {
  const allowed = usePermission(permission);
  if (!allowed) return /* @__PURE__ */ jsx(Fragment, { children: fallback });
  return /* @__PURE__ */ jsx(Fragment, { children });
}

export { AuthGuard, PermissionGuard, useAuth, useCsrfToken, usePermission };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map